import { render, staticRenderFns } from "./CompraDeudaImportPage.vue?vue&type=template&id=36850d1c&scoped=true"
import script from "./CompraDeudaImportPage.vue?vue&type=script&lang=js"
export * from "./CompraDeudaImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36850d1c",
  null
  
)

export default component.exports